/*
 * Creates our global module manager and adds it to the rs namespace
 */

rs.module = (function ModuleManager() {

    var modules = {};

    //
    // Called with all 3 arguments defines a new module.  Called with 1 argument it will return a previously registered module.
    //
    // name:         any unqiue string
    // dependencies: array of strings of modules that this module is dependant on.  The modules themselves will be passed
    //               in the same order to the function specified by 'factory' when the definition is invoked.
    // factory:   a function that creates an instance of the module
    //
    function module(name, dependencies, factory) {
        if (arguments.length == 3) {
            _define(name, dependencies, factory);
        }
        else if (arguments.length == 1) {
            return _require(name);
        }
        else {
            throw new Error("'module' function can be called with 1 or 3 arguments. " + arguments.length + " arguments passed.");
        }
    }

    //
    // Define the given module.  See 'module' function for description.
    //
    function _define(name, dependencies, factory) {

        if (modules[name]) {
            throw new Error("Module '" + name + "' has already been defined.");
        }

        if (dependencies.length != factory.length) {
            throw new Error(`Module '${name}' declared ${dependencies.length} dependencies but the initializing factory function has ${factory.length} arguments.`);
        }

        modules[name] = {
            name: name,
            dependencies: dependencies,
            factory: factory,
            instance: null
        };
    }

    //
    // Load the previously registered module by name
    //
    function _require(name) {
        var module = modules[name];

        if (!module) {
            throw new Error("Module '" + name + "' has not been defined.");
        }

        if (module.instance) {
            return module.instance;
        }

        var dependencies = [];

        // Load each dependency
        for (var i = 0; i < module.dependencies.length; i++) {
            dependencies[i] = _require(module.dependencies[i]);
        }

        // Create the new module instance
        return module.instance = module.factory.apply(module.factory, dependencies);
    }

    // We just export the module function 
    return module;
})();